import React, { useState, useRef, useEffect } from "react";
import { IonApp, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle, IonPage, IonRadio, IonRadioGroup, IonTitle, IonToolbar } from '@ionic/react';
import topics from "../../../menus/UKG/SenseOrgan";

const SenseOrgan: React.FC = () => {

    const handleSubmit = (url: string) => {
        window.location.href = url;
    }

    useEffect(() => {
        document.title = "Mamas Guidance - UKG - General Awareness - Sense Organ"; // Set page title
    }, []);

    return (
        <div className={`my-topic-container`}>
            {topics.map((slide, index) => (
                <IonItem key={index} routerLink={slide.url}
                    routerDirection="none"
                    lines="none"
                    detail={true}>
                    <IonLabel>{slide.title}</IonLabel>
                </IonItem>
            ))}
        </div>
    );
};
export default SenseOrgan;